<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-layout wrap="">
        <v-flex xs12 sm6 md2>
          <v-autocomplete
            v-model="select_store"
            :items="stores"
            item-text="name"
            item-value="id"
            label=" أختر المخزن "
            persistent-hint
            return-object
            single-line
            @change="get_items"
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-autocomplete
            v-model="select_item"
            :items="items"
            item-text="name"
            item-value="id"
            label="أختر الصنف"
            persistent-hint
            return-object
            single-line
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>

        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog_from"
            v-model="modal_from"
            :return-value.sync="date_from"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date_from"
                label="تاريخ من"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date_from" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal_from = false"
                >Cancel</v-btn
              >
              <v-btn
                flat
                color="primary"
                @click="$refs.dialog_from.save(date_from)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog_to"
            v-model="modal_to"
            :return-value.sync="date_to"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date_to"
                label="تاريخ الي"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date_to" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal_to = false"
                >Cancel</v-btn
              >
              <v-btn flat color="primary" @click="$refs.dialog_to.save(date_to)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>

        <v-flex xs12 sm6 md2>
          <v-btn @click="card_sanf">تأكيد</v-btn>
        </v-flex>

        <v-flex xs12 sm12 md12>
          <p style="font-size: 25px; font-weight: bold;">
            مجموع المبيعات : {{ sales_sum }}
          </p>
          <p style="font-size: 25px; font-weight: bold;">
            مجموع المرتجعات : {{ reback_sum }}
          </p>
          <p style="font-size: 25px; font-weight: bold;">
            مجموع التحويلات : {{ transfer_sum }}
          </p>
        </v-flex>
      </v-layout>
      <v-tabs v-model="active" color="cyan" dark slider-color="yellow">
        <v-tab ripple>
          المبيعات
        </v-tab>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="fatworas_client"
                class="elevation-1"
                v-if="fatworas_client.length > 0"
                :rows-per-page-items="rowsPerPageItems"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-right">
                    {{ props.item.fatwora.client_name }}
                  </td>
                  <td class="text-xs-right">
                    {{ props.item.fatwora.emp_sales_response_name }}
                  </td>
                  <td class="text-xs-right">{{ props.item.item_num_after }}</td>
                </template>
              </v-data-table>
              <div style="height:100px" v-else>لا يوجد بيانات</div>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab ripple>
          المرتجعات
        </v-tab>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="fatworas_reback"
                class="elevation-1"
                v-if="fatworas_reback.length > 0"
                :rows-per-page-items="rowsPerPageItems"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-right">
                    {{ props.item.fatwora.client.name }}
                  </td>
                  <td class="text-xs-right">
                    {{ props.item.fatwora.emp_sales_response_name }}
                  </td>
                  <td class="text-xs-right">{{ props.item.item_num_after }}</td>
                </template>
              </v-data-table>
              <div style="height:100px" v-else>لا يوجد بيانات</div>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab ripple>
          التحويلات
        </v-tab>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-data-table
                :headers="headers2"
                :items="fatworas_transfer"
                class="elevation-1"
                v-if="fatworas_transfer.length > 0"
                :rows-per-page-items="rowsPerPageItems"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-right">
                    {{ props.item.fatwora.store_name_from }}
                  </td>
                  <td class="text-xs-right">
                    {{ props.item.fatwora.store_name_to }}
                  </td>
                  <td class="text-xs-right">{{ props.item.item_num }}</td>
                </template>
              </v-data-table>
              <div style="height:100px" v-else>لا يوجد بيانات</div>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab ripple>
          رصيد سابق وحالي
        </v-tab>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <p style="font-size: 20px; font-weight: bold;">
                الرصيد السابق : {{ store_item.start }}
              </p>
              <p style="font-size: 20px; font-weight: bold;">
                الرصيد الحالي : {{ store_item.quantity }}
              </p>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  items_of,
  search_client_by_code,
  madionia_client,
  fatworas_client_no_sadad,
  stores,
  khazina,
  khazna_fatworas,
  card_sanf,
  log_me
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    date_from: new Date().toISOString().substr(0, 10),
    date_to: new Date().toISOString().substr(0, 10),
    menu_from: false,
    modal_from: false,
    menu_to: false,
    modal_to: false,
    menu2: false,

    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: " اسم العميل",
        align: "right",
        value: "name",
        sortable: false
      },
      { text: " المندوب", value: "address", sortable: false, align: "right" },
      { text: " العدد", value: "address", sortable: false, align: "right" }
    ],
    headers2: [
      {
        text: " مخزن من",
        align: "right",
        value: "name",
        sortable: false
      },
      { text: " مخزن الي", value: "address", sortable: false, align: "right" },
      { text: " العدد", value: "address", sortable: false, align: "right" }
    ],
    active: "",
    select_item: { id: "" },
    select_store: { id: "" },
    search: "",
    comment: "",
    loading: true,

    khazina_fatworas: [],
    items: [],
    fatworas: [],
    stores: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theKhazna: {},
    money: "",
    searchClientCode: "",
    madionia_sabqa: "",
    madionia_sabqa_of_madionia: "",
    fatworas_client: [],
    fatworas_reback: [],
    fatworas_transfer: [],
    store_item: {},
    sales_sum: "",
    reback_sum: "",
    transfer_sum: ""
  }),

  computed: {
    mycode() {
      if (this.khazina_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.khazina_fatworas[this.khazina_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      stores().then(response => {
        this.stores = response.data;
        this.loading = false;
      });

      khazna_fatworas().then(response => {
        this.khazina_fatworas = response.data;
      });
    },
    get_items() {
      items_of(this.select_store.id).then(response => {
        this.items = response.data;
      });
    },
    search_client_by_code() {
      search_client_by_code(this.searchClientCode).then(response => {
        this.select_item = response.data;
        this.get_all_info();
      });
    },
    get_all_info() {
      this.searchClientCode = this.select_item.code;
      this.fatworas = [];
      this.madionia_sabqa = "";
      this.loading = true;
      fatworas_client_no_sadad(this.select_item.id).then(response => {
        this.fatworas = response.data;
        this.loading = false;
      });
      madionia_client(this.select_item.id).then(response => {
        this.madionia_sabqa =
          (response.data.madionia != 0
            ? parseFloat(response.data.madionia)
            : 0) +
          (response.data.client.rasid_efttahi != ""
            ? parseFloat(response.data.client.rasid_efttahi)
            : 0);
        this.madionia_sabqa_of_madionia =
          response.data.madionia != 0 ? parseFloat(response.data.madionia) : 0;
      });
    },

    get_khazina() {
      khazina(this.select_store.id).then(response => {
        this.theKhazna = response.data;
      });
    },
    next() {
      const active = parseInt(this.active);
      this.active = active < 3 ? active + 1 : 0;
    },
    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    card_sanf() {
      let myUser = JSON.parse(localStorage.getItem("user"));

      var frmData = new FormData();
      frmData.append("store_id", this.select_store.id);
      frmData.append("item_id", this.select_item.id);
      frmData.append("date_from", this.date_from);
      frmData.append("date_to", this.date_to);
      card_sanf(frmData).then(response => {
        response.data.fatworas_client.length > 0
          ? (this.fatworas_client = response.data.fatworas_client)
          : (this.fatworas_client = []);
        response.data.fatworas_reback.length > 0
          ? (this.fatworas_reback = response.data.fatworas_reback)
          : (this.fatworas_reback = []);
        response.data.fatworas_transfer.length > 0
          ? (this.fatworas_transfer = response.data.fatworas_transfer)
          : (this.fatworas_transfer = []);
        this.store_item = response.data.store_item;
        this.sales_sum = response.data.sales_sum;
        this.reback_sum = response.data.reback_sum;
        this.transfer_sum = response.data.transfer_sum;
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
